import { pageState } from 'State/page'
import type { SearchImportsRequest } from 'Types/beRecipientsApi'
import { atom, selector, selectorFamily } from 'recoil'
import type {
  ImportStatus,
  ModalClauseImportState,
  ModalDelesteImpostsState,
  SelectionState,
  TableState,
} from '../model'

export const errorState = atom<boolean>({
  key: 'recipientsImportStatusErrorState',
  default: false,
})

export const imporRunningState = atom<boolean>({
  key: 'recipientsImportStatusImportStartedState',
  default: false,
})

export const tableToImportState = atom<TableState>({
  key: 'recipientsImportStatusTableToImportState',
  default: {
    loading: true,
    items: [],
    totalItems: 0,
    pageSize: 5,
    pageNumber: 1,
    orderBy: 'Id',
    orderDescending: true,
    isInit: true,
  },
})

export const tableImportedState = atom<TableState>({
  key: 'recipientsImportStatusTableImportedState',
  default: {
    loading: true,
    items: [],
    totalItems: 0,
    pageSize: 5,
    pageNumber: 1,
    orderBy: 'StartDate',
    orderDescending: true,
    isInit: true,
  },
})

export const tableImportedSearchState = atom<SearchImportsRequest>({
  key: 'recipientsImportStatusTableImportedSearchState',
  default: {
    Status: [3, 4],
    Filename: '',
    StartDateFrom: '',
    StartDateTo: '',
  },
})

export const selectionState = atom<SelectionState>({
  key: 'recipientsImport_selectionState',
  default: {
    mode: 'selection',
    checked: [],
    unchecked: [],
  },
})

export const isSelectAllCheckedState = selector<boolean>({
  key: 'recipientsImport_isSelectAllCheckedState',
  get: ({ get }) => {
    const { mode, checked } = get(selectionState)
    const { items } = get(tableImportedState)

    return (
      mode === 'all' ||
      (mode === 'selection' && items.every((r) => checked.includes(r.Id)))
    )
  },
})

export const isSelectAllIndeterminateState = selector<boolean>({
  key: 'recipientsImport_isSelectAllIndeterminateState',
  get: ({ get }) => {
    const { mode, checked } = get(selectionState)
    const { items } = get(tableImportedState)

    const inPageChecked = checked.filter((c) => items.some((r) => r.Id === c))
    return (
      mode === 'selection' &&
      inPageChecked.length > 0 &&
      inPageChecked.length < items.length
    )
  },
})

export const isSelectRecipientDisabled = selector<boolean>({
  key: 'recipientsImport_isSelectRecipientDisabled',
  get: ({ get }) => {
    const { mode } = get(selectionState)

    return mode === 'all'
  },
})

export const isRecipientSelected = selectorFamily<boolean, number>({
  key: 'recipientsImport_isRecipientSelected',
  get:
    (idRecipient: number) =>
    ({ get }) => {
      const { mode, checked } = get(selectionState)

      return mode === 'all' || checked.includes(idRecipient)
    },
})

export const selectionCountState = selector<number>({
  key: 'recipientsImport_selectionCountState',
  get: ({ get }) => {
    const { mode, checked } = get(selectionState)
    const { totalItems } = get(tableImportedState)

    return mode === 'selection' ? checked.length : totalItems
  },
})

export const isEmptyStateStatus = selector<boolean>({
  key: 'recipientsImport_isEmptyStateSTatus',
  get: ({ get }) => {
    const {
      totalItems: totalItemsImported,
      isInit,
      loading: loadingImported,
    } = get(tableImportedState)
    const { totalItems: totalItemsToImport, loading: loadingToImport } =
      get(tableToImportState)
    const { status } = get(pageState)
    
    return (
      status === 'ready' &&
      totalItemsImported === 0 &&
      totalItemsToImport === 0 &&
      !loadingImported &&
      !loadingToImport
    )
  },
})

export const modalDelesteImpostsState = atom<ModalDelesteImpostsState>({
  key: 'recipientsImportModalDelesteImpostsState',
  default: {
    show: false,
    title: '',
    descr: '',
    id: 0,
    source: '',
  },
})

export const modalClauseImportState = atom<ModalClauseImportState>({
  key: 'recipientsImportModalClauseImportState',
  default: {
    show: false,
  },
})

export const importStatus = atom<ImportStatus>({
  key: 'recipientsImport_importStatus',
  default: {
    status: 'stop',
  },
})
